import type { Issuer } from '#shared/utils/auth'

/**
 * Tell us which issuer the current user belongs to, sessions before the migration defaults to 'am'
 */
export function useIssuer() {
  const { session } = useUserSession()

  return computed((): Issuer => {
    return session?.value?.issuer ?? 'am'
  })
}